import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";
import WhatsappDashboardTable from './WhatsappDashboardTable';
import WhatsappFormNoAuth from './WhatsappFormNoAuth';
import SendMessageForm from './SendMessageForm';
import WebhookForm from './WebhookForm';
import PaymentForm from './PaymentForm';


const WhatsappDashboardNoAuth = () => {
  const [phonenumberdata, setphonenumberdata] = useState([]);
 
  const [showmodal, setshowmodal] = useState("showwhatsappform");
  const [formdata, setformdata] = useState({phonenumber:"", name:"", _id: null});

  const fetchdata = async () => {
    try {
      console.log("fetchdata called");
    } catch (err) { console.error(err); }
  };


  const openedit = (item) => {
    setformdata({ name: item.name, phonenumber: item.phonenumber, _id: item._id});
    setshowmodal("showwhatsappform");
  };

  const handlesubmit = async () => {
    let payload = {data:{...formdata, datatype:"phonenumberdata", datetime:formdata.date+"T"+formdata.time}};

    const params = new URLSearchParams(window.location.search);

    payload.adminuserid = params.get("adminuserid");
    payload.userid = params.get("userid");
    
    console.log(payload);
    
    const result = await updatedata(payload, "/updatephonenumbernoauth");
    setshowmodal(false);
    alert("Integration completed");
  };

  useEffect(() => { fetchdata(); }, []);
  

  return (
    <div className="content-area">

      <WhatsappFormNoAuth
        formdata={formdata} 
        setformdata={setformdata}
        handlesubmit={handlesubmit}
      />


    </div>
  );
};

export default WhatsappDashboardNoAuth;